import { View, Text } from "@react-pdf/renderer";

function Tag({ children }: { children: any }) {
	return (
		<View
			style={{
				flexDirection: "row",
				alignItems: "center",
				alignSelf: "flex-start",
				backgroundColor: "#FAFAFA",
				paddingHorizontal: 4,
				paddingVertical: 2,
				border: "1px solid #D9D9D9",
				borderRadius: 2,
				marginBottom: 4,
			}}
		>
			<Text>{children}</Text>
		</View>
	);
}

export default Tag;
